import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
import BaseCostSetting from '../entities/overseasbastcoststting'
import appconst from '@/lib/appconst';


interface BaseCostSettingState extends ListState<BaseCostSetting> {
    total: any;
    BaseCostSettingInfo: BaseCostSetting,
}

class BaseCostSettingMutations extends ListMutations<BaseCostSetting>{

}
class BaseCostSettingInfo extends ListModule<BaseCostSettingState, any, BaseCostSetting>{
    state = {
        totalCount: 0,
        total: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<BaseCostSetting>(),
        loading: false,
        basecostsettings: BaseCostSetting,
        id: 0,

    }
    actions = {
        async getAll(context: ActionContext<BaseCostSettingState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/OverseasBaseCostSetting/GetOverseasBaseCostSettingList', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<BaseCostSetting>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async Add(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/OverseasBaseCostSetting/Add', payload.data);
        },
        async updateStatus(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/OverseasBaseCostSetting/EditList', payload.data);
        },
        async editEndTime(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/OverseasBaseCostSetting/EditEndTime', payload.data);
        },
    };
}

const basecostsettinginfo = new BaseCostSettingInfo();
export default basecostsettinginfo;